export default __webpack_public_path__ + "static/media/fit-food-telegram-bot.28de6dd1.jpg";